document.addEventListener('DOMContentLoaded', function () {
  var SUPPRESS_KEY = 'siscode_popup_dismissed_until';
  var SUPPRESS_MS = 30 * 24 * 60 * 60 * 1000; // one month
  var scrim = document.getElementById('hangerScrim');
  var popup = document.getElementById('hangerPopup');
  if (!scrim || !popup) return;

  function isSuppressed() {
    try {
      var until = Number(localStorage.getItem(SUPPRESS_KEY));
      return until > Date.now();
    } catch (e) {
      return false;
    }
  }
  function suppressForAMonth() {
    try { localStorage.setItem(SUPPRESS_KEY, String(Date.now() + SUPPRESS_MS)); } catch (e) {}
  }

  // Locks the background in place while the popup is open. Mobile Safari/Chrome have long-
  // standing bugs where a `position: fixed` overlay can visibly flicker or briefly vanish if
  // the page behind it is still scrollable and the browser's address bar animates in/out
  // (e.g. from a stray touch/scroll on the page behind the popup) — desktop has no such
  // dynamic toolbar, which is why this was never visible there. `overflow: hidden` on body
  // alone doesn't reliably stop this on iOS, so the body is pinned with `position: fixed` at
  // its current scroll offset instead, and restored exactly on close.
  var lockScrollY = 0;
  function lockBodyScroll() {
    lockScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockScrollY);
  }

  function openHanger() {
    scrim.classList.add('open');
    popup.classList.add('open');
    lockBodyScroll();
  }
  // SISCODE: every dismissal path (backdrop click, Escape, "No thanks") now suppresses the
  // popup for a month, not just "No thanks" specifically. Previously, closing it any other
  // way left the popup un-suppressed, so it popped back up on the very next page load/refresh
  // — read as an unwanted "blinking/popping" bug during normal browsing, since most people
  // dismiss an overlay by clicking outside it or pressing Escape, not by hunting for a specific
  // "No thanks" link.
  function closeHanger() {
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    scrim.classList.remove('open');
    popup.classList.remove('open');
    unlockBodyScroll();
    suppressForAMonth();
  }

  // Shown on every page load for logged-out visitors (gated server-side in
  // theme.liquid via {% unless customer %}), unless they've dismissed it
  // (any way) within the last month.
  if (!isSuppressed()) {
    setTimeout(openHanger, 1200);
  }

  scrim.addEventListener('click', closeHanger);
  var skipBtn = document.getElementById('hangerSkip');
  if (skipBtn) skipBtn.addEventListener('click', closeHanger);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('open')) closeHanger();
  });

  // Subscribe carries the typed email into Shopify's real sign-in/create-account page
  // (as a best-effort prefill query param — harmless if the destination ignores it).
  var subscribeBtn = document.getElementById('hangerSubscribeBtn');
  var emailInput = document.getElementById('hangerEmail');
  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', function () {
      var url = subscribeBtn.getAttribute('data-href');
      var email = emailInput ? emailInput.value.trim() : '';
      if (email) {
        try {
          var u = new URL(url, window.location.origin);
          u.searchParams.set('email', email);
          url = u.toString();
        } catch (e) {}
      }
      window.top.location.href = url;
    });
  }

  // Exposed so other widgets (e.g. the chat/help panel's login-gated Submit button) can
  // trigger this same popup instead of building their own separate login UI.
  window.SiscodeHanger = { open: openHanger, close: closeHanger };
});
